document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('Search');
  const wideModal = document.getElementById('doofinder-wide-modal');
  const chipsContainer = document.getElementById('df-chips');
  const categoriesList = document.getElementById('df-categories');
  const productsGrid = document.getElementById('df-products');
  const closeBtn = document.getElementById('df-close');
  const viewAllBtn = document.getElementById('df-view-all');
  const productGrid = document.querySelector('#doofinder-product-grid');

  if (!searchInput) return;

  // ==========================================
  // TEIL 1: DAS LIVE-OVERLAY BEIM TIPPEN
  // ==========================================
  if (wideModal) {
    if (closeBtn) closeBtn.addEventListener('click', () => { wideModal.style.display = 'none'; });

    document.addEventListener('click', function(event) {
      if (!searchInput.contains(event.target) && !wideModal.contains(event.target)) {
        wideModal.style.display = 'none';
      }
    });

    searchInput.addEventListener('focus', function() {
      if (searchInput.value.trim().length >= 2) wideModal.style.display = 'block';
    });

    let overlayTimer;
    searchInput.addEventListener('input', function() {
      clearTimeout(overlayTimer);
      const searchTerm = searchInput.value.trim();

      if (searchTerm.length < 2) {
        wideModal.style.display = 'none';
        return;
      }

      wideModal.style.display = 'block';
      if(viewAllBtn) viewAllBtn.href = `/search?q=${searchTerm}`;

      overlayTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=query,collection,product&resources[limit]=5`)
          .then(response => response.json())
          .then(data => {
            const queries = data.resources.results.queries || [];
            const collections = data.resources.results.collections || [];
            const products = data.resources.results.products || [];

            // 1. Chips (Bubbles)
            let chipsHtml = '';
            if (queries.length > 0) {
              queries.forEach(query => {
                const boldText = query.text.replace(new RegExp(`(${searchTerm})`, 'gi'), '<b>$1</b>');
                chipsHtml += `<a href="${query.url}" style="border: 1px solid #ccc; border-radius: 20px; padding: 4px 14px; text-decoration: none; color: #555; font-size: 13px; display: inline-block;">${boldText}</a>`;
              });
            } else {
              chipsHtml = '<span style="color: #999; font-size: 13px;">Keine Vorschläge</span>';
            }
            if (chipsContainer) chipsContainer.innerHTML = chipsHtml;

            // 2. Kategorien (Links)
            let catHtml = '';
            if (collections.length > 0) {
              collections.forEach(col => {
                catHtml += `<li><a href="${col.url}" style="text-decoration: none; color: #555; display: block;">${col.title}</a></li>`;
              });
            } else {
              catHtml = '<li style="color: #999;">Keine Kategorien passend</li>';
            }
            if (categoriesList) categoriesList.innerHTML = catHtml;

            // 3. Produkte (Rechts)
            let pHtml = '';
            const displayProducts = products.slice(0, 4); 
            if (displayProducts.length > 0) {
              displayProducts.forEach(product => {
                pHtml += `
                  <a href="${product.url}" style="text-decoration: none; color: #333; border: 1px solid #eaeaea; border-radius: 4px; padding: 15px; display: flex; flex-direction: column; justify-content: space-between; transition: box-shadow 0.2s;">
                    <div style="text-align: center; margin-bottom: 15px;">
                      <img src="${product.image}" alt="${product.title}" style="max-width: 100%; height: 140px; object-fit: contain;">
                    </div>
                    <div>
                      <div style="font-size: 13px; margin-bottom: 10px; line-height: 1.4; color: #555;">${product.title}</div>
                      <div style="font-weight: bold; font-size: 15px; color: #000;">${product.price}</div>
                    </div>
                  </a>
                `;
              });
            } else {
              pHtml = '<div style="grid-column: 1 / -1; color: #999;">Keine Produkte gefunden.</div>';
            }
            if (productsGrid) productsGrid.innerHTML = pHtml;
            
          })
          .catch(error => console.error('Fehler beim Laden:', error));
      }, 250);
    });
  }

  // ==========================================
  // TEIL 2: FILTER AUF DER SEITE (Ohne Neuladen)
  // ==========================================
  function fetchResults(url) {
    const loader = document.querySelector('[data-loading]');
    if(loader) loader.style.display = 'block';
    if(productGrid) productGrid.style.opacity = '0.5';

    fetch(`${url}&section_id=main-search`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(html, 'text/html');
        const newGrid = newDoc.querySelector('#doofinder-product-grid');

        if (newGrid && productGrid) {
          productGrid.innerHTML = newGrid.innerHTML;
          productGrid.style.opacity = '1';
        }
        if(loader) loader.style.display = 'none';

        window.history.replaceState({}, '', url);
      })
      .catch(error => console.error('Fehler beim Laden der Suche:', error));
  }

  document.body.addEventListener('change', function(event) {
    if (event.target.closest('form.facets__form, form.filter-form, #FacetFiltersForm')) {
      event.preventDefault();
      const filterForm = event.target.closest('form');
      const formData = new FormData(filterForm);
      const searchParams = new URLSearchParams(formData);
      
      if (searchInput && searchInput.value) {
        searchParams.set('q', searchInput.value);
      }
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      fetchResults(newUrl);
    }
  });
});